export default {
  release: '17.10',
  date: 'March 2025',
  releasePostUrl: 'https://docs.gitlab.com/releases/17/gitlab-17-10-released/#this-months-notable-contributor-alexey-butkeev',
  contributors: [
    {
      name: 'Alexey Butkeev',
      gitlabUsername: 'abutkeev',
    },
  ],
  writeUp: `Alexey Butkeev is a valued community contributor whose contributions enhance our global reach and user experience. His impactful localization and translation contributions exemplify our Diversity, Inclusion, and Belonging value.

"I'm honored to be selected as the 17.10 MVP and to contribute to making GitLab more accessible and inclusive," says Alexey.
"Localization is a team effort, and I'm grateful to be part of such a supportive community."

In addition to his code contributions, Alexey took the initiative to find, document, and fix translation errors via GitLab and Crowdin. His thorough research and problem solving make him our 17.10 MVP.

Alexey was nominated by [Oleksandr Pysaryuk](https://gitlab.com/opysaryuk), Senior Manager, Globalization Technology at GitLab, and supported by [Daniel Sullivan](https://gitlab.com/djsulliv), Director of Globalization & Localization at GitLab.
"We appreciate your work and support here at GitLab so much," says Daniel.
"Thank you for your part in helping us become a more globally supported company!"

Thank you Alexey for making GitLab more inclusive and transparent!`,
};
